import { Component, Input } from '@angular/core';

import { AuthService } from '../../service/auth.service';
import { ApiService } from '../../service/api.service';
import { EventService } from '../../service/event.service';

@Component({
    selector: 'app-download-modal',
    templateUrl: './download-modal.page.html',
    styleUrls: ['./download-modal.page.scss'],
})
export class DownloadModalPage
{
    private files = [];
    private is_load = false;

    constructor(
        private auth: AuthService,
        private api: ApiService,
        private event: EventService
    )
    {
    }

    async ngOnInit()
    {
        this.event.modal_subject.next({key: "modalSubscribe", id: 'download-modal', value: null});
        await this.getArchiveList();
    }

    async getArchiveList()
    {
        this.is_load = true;
        this.files = [];
        this.files = await this.api.zipprogress();
        this.is_load = false;
    }

    async refresh()
    {
        await this.getArchiveList();
    }

    async startDownload(file)
    {
        if (file.percent < 100) return;

        this.event.modal_subject.next({key: "closeModal", id: 'download-modal', value: { file: file }});
    }

    async downloadClose()
    {
        this.event.modal_subject.next({key: "closeModal", id: 'download-modal', value: null});
    }
}
